"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isItemOver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors,
    direction = _useContext.direction;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    setEndDirection = _useStylesUtils.setEndDirection;
  var ccItemStyle = (0, _react.useMemo)(function () {
    var viewProps = function viewProps() {
      if (view === 'horizontal') {
        return {
          width: '100%'
        };
      }
      return {
        width: pxToRem(220),
        minHeight: pxToRem(258),
        height: '100%'
      };
    };
    var preloaderViewProps = function preloaderViewProps() {
      if (view === 'horizontal') {
        return {
          width: pxToRem(126)
        };
      }
      return {};
    };
    var containerViewProps = function containerViewProps() {
      if (view === 'horizontal') {
        return {
          display: 'grid',
          gridTemplateColumns: "".concat(pxToRem(126), " 1fr"),
          gridTemplateRows: 'auto auto',
          borderRadius: pxToRem(6),
          overflow: 'hidden',
          background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light
        };
      }
      return {
        display: 'flex',
        flexDirection: 'column'
      };
    };
    var bannerViewProps = function bannerViewProps() {
      if (view === 'horizontal') {
        return {
          width: pxToRem(126),
          borderRadius: pxToRem(0)
        };
      }
      return {
        width: pxToRem(220),
        height: pxToRem(186),
        borderRadius: pxToRem(5),
        textAlign: 'center'
      };
    };
    var bannerContentDeviceProps = function bannerContentDeviceProps() {
      if (isMobileView) {
        return {
          opacity: 1
        };
      }
      return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        borderRadius: pxToRem(5),
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: 'transparent linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.41) 100%) 0% 0% no-repeat padding-box',
        opacity: isItemOver ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out'
      };
    };
    var contentViewProps = function contentViewProps() {
      if (view === 'horizontal') {
        return {
          minHeight: pxToRem(115),
          boxSizing: 'border-box',
          padding: "".concat(pxToRem(13), " ").concat(pxToRem(14), " ").concat(pxToRem(9)),
          display: 'block',
          position: 'relative'
        };
      }
      return {
        flexGrow: 1,
        padding: "".concat(pxToRem(9), " ").concat(pxToRem(3), " ").concat(pxToRem(3)),
        display: 'flex',
        flexDirection: 'column'
      };
    };
    var titleViewProps = function titleViewProps() {
      if (view === 'horizontal') {
        return {
          fontSize: pxToRem(16),
          lineHeight: pxToRem(18)
        };
      }
      return {
        fontSize: pxToRem(15),
        lineHeight: pxToRem(17)
      };
    };
    var infoViewProps = function infoViewProps() {
      if (view === 'horizontal') {
        return {
          position: 'absolute',
          left: pxToRem(14),
          right: pxToRem(14),
          bottom: pxToRem(9),
          fontSize: pxToRem(14),
          lineHight: pxToRem(16)
        };
      }
      return {
        width: '100%',
        fontSize: pxToRem(13),
        lineHeight: pxToRem(16),
        marginBottom: pxToRem(9)
      };
    };
    var extraContentViewProps = function extraContentViewProps() {
      if (view === 'horizontal') {
        return {
          gridColumnStart: 1,
          gridColumnEnd: 3,
          cursor: 'pointer'
        };
      }
      return {};
    };
    var ccItem = (0, _css.css)(_objectSpread({
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      borderRadius: "".concat(pxToRem(5), " ").concat(pxToRem(5), " 0 0"),
      opacity: 1,
      maxHeight: pxToRem(305),
      transition: 'opacity 0.5s ease, height 0.5s ease-in-out, width 0.5s ease-in-out, transform 0.5s ease-in-out',
      userSelect: 'none',
      boxSizing: 'content-box'
    }, viewProps()));
    var ccItemPreloader = (0, _css.css)(_objectSpread({
      backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      borderRadius: "".concat(pxToRem(5), " ").concat(pxToRem(5), " 0 0"),
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1
    }, preloaderViewProps()));
    var ccItemTags = (0, _css.css)(_objectSpread(_objectSpread({
      direction: direction,
      position: 'absolute',
      top: pxToRem(-7),
      display: 'flex',
      minWidth: '50%',
      justifyContent: 'flex-end',
      margin: "0 ".concat(pxToRem(3))
    }, setEndDirection(16)), {}, {
      '& > div': {
        marginInlineStart: pxToRem(13),
        boxShadow: "0 ".concat(pxToRem(1), " ").concat(pxToRem(2), " #00000029")
      }
    }));
    var ccItemContainer = (0, _css.css)({
      height: '100%',
      visibility: isReady ? 'visible' : 'hidden'
    });
    var ccItemMainContent = (0, _css.css)(_objectSpread({
      position: 'relative',
      width: '100%',
      height: '100%',
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text
    }, containerViewProps()));
    var ccItemBanner = (0, _css.css)(_objectSpread({
      position: 'relative',
      backgroundColor: '#e8e8f6',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, bannerViewProps()));
    var ccItemBannerContent = (0, _css.css)(_objectSpread({}, bannerContentDeviceProps()));
    var ccItemContent = (0, _css.css)(_objectSpread({}, contentViewProps()));
    var ccItemTitle = (0, _css.css)(_objectSpread({
      maxHeight: pxToRem(34),
      fontWeight: 'bold',
      marginBottom: pxToRem(1),
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }, titleViewProps()));
    var ccItemInfo = (0, _css.css)(_objectSpread({
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      transition: 'none',
      flexGrow: 1,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
    }, infoViewProps()));
    var ccItemSubTitle = (0, _css.css)({
      marginInlineEnd: pxToRem(20),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
    });
    var ccItemDuration = (0, _css.css)({});
    var ccItemExtraContent = (0, _css.css)(_objectSpread({
      position: 'relative',
      width: '100%'
    }, extraContentViewProps()));
    var ccItemExtraInfo = (0, _css.css)({
      position: 'relative',
      '&:empty': {
        display: 'none'
      }
    });
    return {
      ccItem: ccItem,
      ccItemPreloader: ccItemPreloader,
      ccItemTags: ccItemTags,
      ccItemContainer: ccItemContainer,
      ccItemMainContent: ccItemMainContent,
      ccItemBanner: ccItemBanner,
      ccItemBannerContent: ccItemBannerContent,
      ccItemContent: ccItemContent,
      ccItemTitle: ccItemTitle,
      ccItemInfo: ccItemInfo,
      ccItemSubTitle: ccItemSubTitle,
      ccItemDuration: ccItemDuration,
      ccItemExtraContent: ccItemExtraContent,
      ccItemExtraInfo: ccItemExtraInfo
    };
  }, [direction, isItemOver, isMobileView, isReady, pxToRem, setEndDirection, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, view]);
  return {
    'cc-Item': ccItemStyle.ccItem,
    'cc-Item__preloader': ccItemStyle.ccItemPreloader,
    'cc-Item__tags': ccItemStyle.ccItemTags,
    'cc-Item__container': ccItemStyle.ccItemContainer,
    'cc-Item__main-content': ccItemStyle.ccItemMainContent,
    'cc-Item__banner': ccItemStyle.ccItemBanner,
    'cc-Item__banner-content': ccItemStyle.ccItemBannerContent,
    'cc-Item__content': ccItemStyle.ccItemContent,
    'cc-Item__title': ccItemStyle.ccItemTitle,
    'cc-Item__info': ccItemStyle.ccItemInfo,
    'cc-Item__sub-title': ccItemStyle.ccItemSubTitle,
    'cc-Item__duration': ccItemStyle.ccItemDuration,
    'cc-Item__extra-content': ccItemStyle.ccItemExtraContent,
    'cc-Item__extra-info': ccItemStyle.ccItemExtraInfo
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;